import { IGEDTornarObsoletosUseCase } from "../../../presentation/useCases/update/ged_tornar_obsoletos_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GEDTornarObsoletosUseCase
 */

export class GEDTornarObsoletosUseCase implements IGEDTornarObsoletosUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async gedTornarObsoleto(
    ids: Set<string | number>,
  ): Promise<void> {
    const idsArquivoDocumento: number[] = [];
    for (let id of ids) {
      if (typeof id === 'number') {
        idsArquivoDocumento.push(id);
      }
      else if (typeof id === 'string') {
        try {
          idsArquivoDocumento.push(Number(id));
        } catch (e: unknown) {
        }
      }
    }
    await this.repository.gedTornarObsoleto(idsArquivoDocumento);
  }
}
